import { Link } from "react-router-dom";

function Page404() {
  const mystyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "calc(100vh - 250px)",
    margin: "50px 0 100px",
    color: "rgb(128 128 128)",
    padding: " 0 5%",
    textAlign: "center",
  };
  const mytitle = {
    color: "#ed1c25",
    fontSize: "4.6rem",
    fontFamily: "Crimson Text",
    fontWeight: "600",
    margin: "0 0 15px",
  };
  const subTitle = {
    margin: "20px 0 0",
    fontSize: "1.8rem",
    fontFamily: '"DM Sans", sans-serif',
  };
  const cta404 = {
    position: "relative",
    border: "none",
    cursor: "pointer",
    background: "#ed1c25",
    padding: "10px",
    color: "#fff",
    borderRadius: "4px",
    textDecoration: "none",
  };

  return (
    <>
      <section style={mystyle}>
        <h1 style={mytitle}>Oops!</h1>
        <h2 style={subTitle}>404 - PAGE NOT FOUND</h2>
        <h3>
          The page you are looking for might be removed or temporarily
          unavailable
        </h3>
        <Link style={cta404} className="cta" to="/">
          GOTO HOMEPAGE
        </Link>
      </section>
    </>
  );
}

export default Page404;
